import loadable from '@loadable/component';

export const OnMetaRequestedNotificationCenterLoadable = loadable(() => import('./OnMetaRequestedNotificationCenter'), {
  ssr: false,
});
